import React from 'react';
import { Providers, ProvidersProps } from './providers';
import { AppProvider } from './providers/app';

type AppProps = ProvidersProps;

export const App: React.FC<AppProps> = ({ ssrMatchMedia }) => {
  return (
    <Providers ssrMatchMedia={ssrMatchMedia}>
      <AppProvider />
    </Providers>
  );
};
